<template>
  <div>
    <b-row>
      <b-modal
        :no-close-on-backdrop="true"
        id="modal-radiology-edit"
        ok-only
        centered
        size="lg"
        :title="createMode ? 'Add Patient Test' : $t('lab.Edit Patient  Test')"
        @ok="submitItem()"
      >
        <b-card-text>
          <b-row>
            <b-col md="12">
              <b-form-group :label="$t('lab.result')" label-for="URL">
                <b-form-input
                  v-model="EditForm.result"
                  :placeholder="$t('lab.result')"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-text>
      </b-modal>
      <DeleteModal modalId="modal-delete" @deleteToggle="deleteTest" />
      <b-modal
        :no-close-on-backdrop="true"
        id="modal-add-discount"
        ok-only
        centered
        size="lg"
        :title="$t('common.add') + ' ' + $t('common.discount')"
        @ok="addDiscount()"
      >
        <b-card-text>
          <b-row>
            <b-col md="12">
              <b-form-group :label="$t('common.discount')">
                <b-form-input
                  v-model="EditForm.discount"
                  :placeholder="$t('common.discount')"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-text>
      </b-modal>
      <b-modal
        :no-close-on-backdrop="true"
        id="modal-add-test"
        ok-only
        centered
        size="lg"
        :title="'Add Patient Test'"
        @ok="addTest()"
      >
        <b-card-text>
          <b-row>
            <b-col md="">
              <AutoComplete
                v-model="group"
                label="Test Group"
                placeholder="Select A Group"
                param-query="search"
                :serializer="(val) => val.id"
                endpoint="group"
                text-title="name"
                @input="selectGroup"
              />
            </b-col>
          </b-row>
          <div class="d-flex">
            <div v-for="(item, index) in CreateForm.tests">
              <b-badge class="mx-1" variant="primary">
                {{ item.test.name }}
                <span @click="removeTest(index)" class="cursor-pointer">X</span>
              </b-badge>
            </div>
          </div>
        </b-card-text>
      </b-modal>

      <b-col>
        <b-card>
          <div class="d-flex justify-content-between">
            <h2 class="mb-2">{{ $t("lab.Patient Test Details") }}</h2>
            <h2 class="mb-2"></h2>
          </div>
          <div class="mb-1">
            <h5>
              {{ $t("common.patient-name") }} : {{ getNestedProperty(patientInfo, 'patient.name') }}
            </h5>
            <h6>{{ $t("lab.gender") }} : {{ getNestedProperty(patientInfo, 'patient.gender') }}</h6>
            <h6>
              {{ $t("common.Birtdate") }} : {{ getNestedProperty(patientInfo, 'patient.birth_date') }}
            </h6>

            <h6>{{ $t("common.phone") }} : {{ getNestedProperty(patientInfo, 'patient.phone') }}</h6>
            <h6>
              {{ $t("emergency.Patient Case") }} :
              {{ getNestedProperty(patientInfo, 'patient_case') }}
            </h6>
            <h6>{{ $t("common.type") }} : {{ getNestedProperty(patientInfo, 'type') }}</h6>
          </div>
          <div class="d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mb-75 bgcolor mx-2"
              @click="
                $router.push({
                  name: 'add-test',
                  params: { id: $route.params.id },
                })
              "
              >{{ $t("lab.add-patient-test") }}
            </b-button>
            <tests :data="data" :patientInfo="patientInfo" />
          </div>

          <b-card>
            <div>
              <b-table
                :items="data"
                responsive
                :fields="tableColumns"
                primary-key="id"
                show-empty
                empty-text="No matching results found"
                class="position-relative"
                v-if="!loading"
              >
                <template #cell(sample_id)="data">
                  <b-button variant="outline-primary" size="sm" pill class="mb-75 bgcolor mx-2" @click="editSampleId(data.item)">
                    {{ getNestedProperty(data.item, 'sample_id') }}
                  </b-button>
                </template>
                <template #cell(test_name)="data">
                  {{ getNestedProperty(data.item, 'test.name') }}
                </template>
                <template #cell(unit)="data">
                  {{ getNestedProperty(data.item, 'unit.name') }}
                </template>
                <template #cell(normalRange)="data">
                  <span class="text-nowrap">
                    {{ getNestedProperty(data.item, 'normal_range_max') }} -
                    {{ getNestedProperty(data.item, 'normal_range_max') }}
                  </span>
                </template>
                <template #cell(state)="data">
                  <div v-if="data.item.sample_id !== null">
                    <b-button
                      v-if="data.item.is_approved === 0"
                      variant="success"
                      size="sm"
                      @click="showApproveModal(data.item)"
                    >
                      {{ $t("lab.Approve") }}
                    </b-button>
                    <b-button
                      v-else
                      variant="danger"
                      size="sm"
                      @click="showDisapproveModal(data.item)"
                    >
                      {{ $t("lab.Disapprove") }}
                    </b-button>
                  </div>
                </template>

                <template #cell(actions)="data">
                  <div class="text-nowrap">
                    <!-- @click="printId(data.item.id)" -->
                    <div class="text-nowrap d-flex gap-2">
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        pill
                        class="mb-75 bgcolor mx-2"
                        @click="show(data, 'update')"
                        >{{ $t("lab.Add result") }}
                      </b-button>
                      <ActionsButtons
                        :noEdit="true"
                        deletePerm="delete-surgery"
                        editPerm="update-surgery"
                        @editToggle="show(data.item)"
                        @deleteToggle="deleteModel(data.item)"
                      />
                    </div>
                    <div class="text-nowrap d-flex gap-2">
                      <b-button
                        variant="outline-success"
                        size="sm"
                        pill
                        class="mb-75 bgcolor"
                        @click="
                          $router.push({
                            name: 'single-test-details',
                            params: {
                              id: data.item.test_id,
                              patientCardId: $route.params.id,
                            },
                          })
                        "
                        >{{ $t("lab.view-test") }}</b-button
                      >
                      <b-button
                        variant="outline-warning"
                        size="sm"
                        pill
                        class="mb-75 bgcolor mx-2"
                        @click="showDiscount(data, 'update')"
                        >{{ $t("lab.add-discount") }}
                      </b-button>

                    </div>
                  </div>
                </template>
              </b-table>
              <template v-if="loading">
                <div>
                  <div class="d-flex justify-content-center mb-1">
                    <b-spinner label="Loading..." />
                  </div>
                </div>
              </template>
              <div class="mx-2 mb-2">
                <b-row>
                  <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-start"
                  >
                    <span class="text-muted">Showing 1 to 10 of tests</span>
                  </b-col>
                  <!-- Pagination -->
                  <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    @click="index()"
                  >
                    <b-pagination
                      v-model="page"
                      :total-rows="dataCount"
                      :per-page="take"
                      first-number
                      last-number
                      class="mb-0 mt-1 mt-sm-0"
                      prev-class="prev-item"
                      next-class="next-item"
                    >
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                    </b-pagination>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-card>
        </b-card>
      </b-col>
    </b-row>

    <!-- Approve Confirmation Modal -->
    <b-modal
      id="approve-modal"
      title="Approve Test"
      @ok="approveTest"
      ok-title="Confirm"
      cancel-title="Cancel"
    >
      <p>Are you sure you want to approve this test?</p>
    </b-modal>

    <!-- Disapprove Confirmation Modal -->
    <b-modal
      id="disapprove-modal"
      title="Disapprove Test"
      @ok="disapproveTest"
      ok-title="Confirm"
      cancel-title="Cancel"
    >
      <p>Are you sure you want to disapprove this test?</p>
    </b-modal>

    <b-modal
      v-model="editSampleModal"
      title="Edit Sample ID"
      cancel-variant="outline-secondary"
      ok-title="Save"
      @ok.prevent="updateSampleId"
    >
      <b-form>
        <b-form-group
          label="Sample ID"
          label-for="sample-id"
        >
          <b-form-input
            id="sample-id"
            v-model="newSampleId"
            placeholder="Enter new sample ID"
            trim
          />
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BLink,
  BFormGroup,
  BFormInput,
  BTable,
  BDropdown,
  BBadge,
  BDropdownItem,
  BPagination,
  BSpinner,
  BModal,
} from "bootstrap-vue";
import axios from "axios";
import router from "@/router";
import ReceptionHistoryCard from "@/components/reception/ReceptionHistoryCard";
import ReceptionPatientCardWithQR from "@/components/reception/ReceptionPatientCardWithQR";
import VueHtml2pdf from "vue-html2pdf";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
const tests = () => import("@/components/printables/Tests.vue");
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";

export default {
  components: {
    DeleteModal,
    ActionsButtons,
    BRow,
    BCol,
    BLink,
    BCard,
    BBadge,
    BButton,
    ReceptionHistoryCard,
    ReceptionPatientCardWithQR,
    VueHtml2pdf,
    StatisticCardHorizontal,
    BFormGroup,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BFormInput,
    BModal,
    tests,
    AutoComplete,
  },

  data() {
    return {
      data: {},
      patientCardDetails: {},
      params: {
        form: {},
        path: "",
      },
      EditForm: {
        id: " ",
        normalRange: " ",
        patient_card_id: "",
        price: " ",
        result: " ",
        unit_id: " ",
        resultAsToNormalRange: " ",
        _method: "PUT",
      },
      CreateForm: {
        patient_card_id: "",
        tests: [],
      },
      dataCount: 0,
      patientInfo: {},
      tableColumns: [
        {
          key: "sample_id",
          sortable: true,

          label: this.$t("lab.sample_id"),
        },
        {
          key: "test_name",
          sortable: true,

          label: this.$t("common.name"),
        },
        {
          key: "result",
          sortable: true,

          label: this.$t("lab.result"),
        },
        {
          key: "unit",
          sortable: true,

          label: this.$t("lab.unit"),
        },
        {
          key: "normalRange",
          sortable: true,

          label: this.$t("lab.normalRange"),
        },
        // {
        //   key: "result_as_to_normal_range",
        //   sortable: true,

        //   label: this.$t("lab.resultAsToNormalRange"),
        // },
        {
          key: "discount",
          sortable: true,

          label: this.$t("common.discount"),
        },
        {
          key: "price_after_discount",
          sortable: true,

          label: this.$t("common.price_after_discount"),
        },
        { key: "Actions", label: this.$t("common.actions") },
        { key: "state", label: this.$t("lab.approve_to_test_result") },
      ],
      Tests: {
        id: "Tests",
      },
      group: "",
      deleteForm: "",
      writeTest: "",
      selectedItem: null, // Store the selected item for approval/disapproval
      createMode: false,
      editSampleModal: false,
      currentSampleId: null,
      newSampleId: '',
    };
  },
  mounted() {
    this.getPatientInfo();
    this.getPatientsInfo();
  },

  methods: {
    getNestedProperty(obj, path, defaultValue = "N/A") {
      const result = path
        .split(".")
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj
        );
      // if (typeof result === "string" && result.startsWith("\\")) {
      //   return defaultValue;
      // }
      // console.log("result", result);
      return result;
    },
    removeTest(index) {
      this.CreateForm.tests.splice(index, 1);
    },
    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    async getPatientsInfo() {
      const Id = this.$route.params.id;
      await this.getPatient(`/patientCard/${Id}`);
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }

      this.patientInfo = this.all_data;
      console.log("this.patientInfo", this.patientInfo);
      this.dataCount = this.all_data.total;
    },
    async getPatientInfo() {
      const Id = this.$route.params.id;

      await this.getPatient(
        `patientCardTest?filter[patient_card_id]=${Id}&include=test,unit&sort=-id`
      );
      this.loading = false;
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }

      this.data = this.all_data.data;
      console.log("this.data", this.data);
      // const dataWithNormalRange = await Promise.all(
      //   this.data.map(async (patientTest) => {
      //     // console.log("patientTest", patientTest.test_id);
      //     const normalRange = await this.getNormalRange(patientTest.test_id);
      //     // console.log("normalRange", normalRange);
      //     return {
      //       ...patientTest,
      //       test: normalRange,
      //     };
      //   })
      // );
      // this.data = dataWithNormalRange;

      // console.log(
      //   "this.data.test.normal_ranges",
      //   this.data[0].test
      // );
      // this.data.map((item) => {
      //   const writeTest = this.getPatientNormalRangeByAgeAndGender(
      //     this.calculateAge(this.patientInfo.patient.birth_date),
      //     this.patientInfo.patient.gender,
      //     item.test.normal_ranges
      //   );
      //   // console.log("writeTest", writeTest);
      //   item.writeTest = writeTest;
      // });

      console.log("this.data", this.data);
    },
    async getNormalRange(testId) {
      await this.getPatient(`/test/${testId}?include=normalRanges`);
      const testWithNormalRange = this.all_data;
      // console.log("testWithNormalRange", testWithNormalRange);
      return testWithNormalRange;
    },
    getPatientNormalRangeByAgeAndGender(
      patientAge,
      patientGender,
      normalRanges
    ) {
      let writeTest = null;
      if (Array.isArray(normalRanges)) {
        normalRanges.map((normalRange) => {
          if (
            normalRange.min_age <= patientAge &&
            normalRange.max_age >= patientAge &&
            normalRange.gender == patientGender
          ) {
            writeTest = normalRange;
          }
        });
      } else {
        console.error("normalRanges is not an array:", normalRanges);
      }
      console.log("writeTest", writeTest);
      return writeTest;
    },
    calculateAge(birth_date) {
      // birth_date = "1950-01-01";
      const today = new Date();
      const birthDate = new Date(birth_date);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      console.log("age", age);
      return age;
    },
    addDiscount() {
      (this.params.form = this.EditForm),
        (this.params.path = `/patientCardTest/${this.EditForm.id}`),
        this.$store
          .dispatch("update", this.params)
          .then((response) => {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Patient Card Test Added",
                variant: "success",
              },
            });
            console.log("joo");
            this.getPatientInfo();
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    submitItem() {
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/patientCardTest`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Patient Card Radiology Added",
                  variant: "success",
                },
              });
              this.getPatientInfo();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/patientCardTest/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Patient Card Test Added",
                  variant: "success",
                },
              });
              console.log("joo");
              this.getPatientInfo();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
    show(item, mode) {
      if (mode === "create") {
        const Id = this.$route.params.id;
        this.createMode = true;
        this.CreateForm.patient_card_id = Id;

        this.$bvModal.show("modal-add-test");
      } else {
        this.createMode = false;

        this.EditForm.id = item.item.id;
        this.EditForm.normalRange = item.item.normalRange;
        this.EditForm.patient_card_id = item.item.patient_card_id;
        this.EditForm.price = item.item.price;
        this.EditForm.result = item.item.result;
        this.EditForm.unit_id = item.item.unit_id;
        this.EditForm._method = "PUT";
        this.$bvModal.show("modal-radiology-edit");
      }
    },
    showDiscount(item) {
      this.EditForm.id = item.item.id;
      this.EditForm.discount = item.item.discount;
      this.EditForm.normalRange = item.item.normalRange;
      this.EditForm.patient_card_id = item.item.patient_card_id;
      this.EditForm.price = item.item.price;
      this.EditForm.result = item.item.result;
      this.EditForm.unit_id = item.item.unit_id;

      this.EditForm._method = "PUT";
      this.$bvModal.show("modal-add-discount");
    },
    async selectGroup(e) {
      await this.getPatient(`/testGroup?filter[group_id]=${e}&include=test`);
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }

      this.CreateForm.tests = this.all_data.data;
    },
    async addTest() {
      (this.params.form = this.CreateForm),
        (this.params.path = `/patientCardTest`),
        this.$store
          .dispatch("create", this.params)
          .then((response) => {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Patient Card Test Added",
                variant: "success",
              },
            });

            this.getPatientInfo();
          })
          .catch((error) => {
            console.log(error);
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    deleteTest() {
      this.$store
        .dispatch("delete", `/patientCardTest/${this.deleteForm.id}`)
        .then((response) => {
          this.getPatientInfo();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    showApproveModal(item) {
      this.selectedItem = item;
      this.$bvModal.show("approve-modal");
    },
    showDisapproveModal(item) {
      this.selectedItem = item;
      this.$bvModal.show("disapprove-modal");
    },
    async approveTest() {
      try {
        // Call your API to update is_approved to 1
        await axios.put(`/patientCardTest/${this.selectedItem.id}`, {
          is_approved: 1,
        });
        // Update the local state
        await this.getPatientInfo();
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Test Approved",
            message: `${this.selectedItem.test.name} approved successfully`,
            variant: "success",
          },
        });
      } catch (error) {
        console.error("Error approving test:", error);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Failed to approve test",
            message: `${error.response.data.message}`,
            variant: "danger",
          },
        });
      } finally {
        this.selectedItem = null; // Reset the selected item
      }
    },
    async disapproveTest() {
      try {
        // Call your API to update is_approved to 0
        await axios.put(`/patientCardTest/${this.selectedItem.id}`, {
          is_approved: 0,
        });
        // Update the local state
        await this.getPatientInfo();
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Test Disapproved",
            variant: "danger",
          },
        });
      } catch (error) {
        console.error("Error disapproving test:", error);
        this.$toast.error("Failed to disapprove test.");
      } finally {
        this.selectedItem = null; // Reset the selected item
      }
    },
    editSampleId(item) {
      this.currentSampleId = item
      // Get current sample ID if needed or leave blank for user to enter new one
      this.editSampleModal = true
    },
    
  
    
    updateSampleId() {
      // Replace with your actual API call
      this.$http.put(`/patientCardTest/${this.currentSampleId.id}`, { sampleId: this.newSampleId })
        .then(() => {
          this.editSampleModal = false
          // Refresh the data or update it locally
          this.refreshData()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Success',
              variant: 'success',
              text: 'Sample ID updated successfully',
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              variant: 'danger',
              text: 'Failed to update Sample ID',
            },
          })
          console.error(error)
        })
    },
  },
};
</script>

<style scoped>
.mb-md-0 {
  margin-top: 8px;
}

table {
  width: 94%;
  border: 1px solid;
  font-size: 11px;
}

.no-border {
  border: 0;
}

.square-dark {
  background-color: rgba(0, 0, 0, 0.2);
}

tr,
th,
td {
  border: 1px solid;
  width: 10px;
  height: 10px;
  text-align: center;
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}

.square {
  width: 30px;
  /* Smaller width for squares */
  height: 30px;
  /* Smaller height for squares */
  background-color: #000;
  /* Color of the square */
  display: inline-block;
  /* Allows us to set width and height */
}

.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

#table-above {
  border-collapse: collapse;
  /* Removes space between borders */
  font-size: 12px;
  /* Smaller font size for the entire table */
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
